import { Component, OnInit, OnDestroy, Input } from '@angular/core';

import { ISubscription } from 'rxjs/Subscription';

import Handsontable from 'handsontable';
import { HotRegisterer } from 'angular-handsontable';
import {Report} from '../shared/report.model';
import {ReportDataService} from '../report-data.service';

@Component({
  selector: 'app-end-items',
  templateUrl: './end-items.component.html',
  styleUrls: ['./end-items.component.css']
})
export class EndItemsComponent implements OnInit, OnDestroy {
  columns: Array<Object>;
  report: Report;
  data: any;
  reloadSubscription: ISubscription;

  constructor(private reportService: ReportDataService, private gridContext: HotRegisterer) {
  }

  ngOnInit() {
    this.report = this.reportService.getReport();
    this.columns = this.report.EndItems.columns;
    this.data = this.report.EndItems.data;
    this.reloadSubscription = this.reportService.getReload().subscribe(data => this.reload());
  }

  ngOnDestroy() {
    this.reloadSubscription.unsubscribe();
  }

  reload() {
    this.data = this.report.EndItems.data;
    const gridInstance = this.gridContext.getInstance('EndItems');
    gridInstance.loadData(this.data);
  }
}  


// WEBPACK FOOTER //
// ./src/app/end-items/end-items.component.ts